// 车牌号
export const vehilceReg = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-Z]{1}(([A-HJ-NP-Z0-9]{5,6}[DF]{1}$)|([DF]{1}[A-HJ-NP-Z0-9]{5,6}$)))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂]{1}$)/;

// 尺寸
export const sizeReg = /((^[1-9]\d*)|^0)(\.\d{0,3}){0,1}$/;

// 字母和数字
export const numAndLetterReg = /^[0-9a-zA-Z]*$/;

// 小数点后两位
export const twoNumberReg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;

// 输入负数
export const nagetiveMoneyReg = (/^([-+])?\d+(\.[0-9]{1,2})?$/);

export const nagetiveIntegerReg = (/^([-+])?[0-9]*$/);
